import { BoxType } from 'src/app/shared/enums/box-type';
import { FilterConsts } from '../consts/filter-consts';
import { OrderVisibility } from 'src/app/shared/models/order-visibility';
import { OrderState } from 'src/app/proxy/orders/enums';

export type OrderInboxStateFilter =
  | typeof FilterConsts.All
  | typeof FilterConsts.Pending
  | typeof FilterConsts.Approved
  | typeof FilterConsts.Delivered
  | typeof FilterConsts.Received
  | typeof FilterConsts.Rejected;

export interface OrderInboxConfiguration {
  boxTypes: readonly BoxType[];
  visibilityByBoxType: Readonly<Partial<Record<BoxType, OrderVisibility>>>;
  stateFiltersByBoxType: Readonly<Partial<Record<BoxType, readonly OrderInboxStateFilter[]>>>;
  newOrderPath?: string;
}

const inPendingApprovedRejectedStates: readonly OrderInboxStateFilter[] = [
  FilterConsts.All,
  FilterConsts.Pending,
  FilterConsts.Approved,
  FilterConsts.Rejected,
];

const outRequesterStates: readonly OrderInboxStateFilter[] = [
  FilterConsts.All,
  FilterConsts.Pending,
  FilterConsts.Approved,
  FilterConsts.Received,
  FilterConsts.Rejected,
];

const warehouseManagerInStates: readonly OrderInboxStateFilter[] = [
  FilterConsts.All,
  FilterConsts.Delivered,
  FilterConsts.Received,
];

const warehouseManagerOutStates: readonly OrderInboxStateFilter[] = [
  FilterConsts.All,
  FilterConsts.Pending,
  FilterConsts.Delivered,
];

export const ORDER_INBOX_CONFIGURATIONS = {
  supervisor: {
    boxTypes: [BoxType.In],
    visibilityByBoxType: { [BoxType.In]: 'all' },
    stateFiltersByBoxType: { [BoxType.In]: inPendingApprovedRejectedStates },
  },
  contractor: {
    boxTypes: [BoxType.Out],
    visibilityByBoxType: { [BoxType.Out]: 'requester' },
    stateFiltersByBoxType: { [BoxType.Out]: outRequesterStates },
    newOrderPath: '/new/contractor',
  },
  silviculture: {
    boxTypes: [BoxType.In, BoxType.Out],
    visibilityByBoxType: {
      [BoxType.In]: 'approver',
      [BoxType.Out]: 'requester',
    },
    stateFiltersByBoxType: {
      [BoxType.In]: inPendingApprovedRejectedStates,
      [BoxType.Out]: outRequesterStates,
    },
    newOrderPath: '/new/silviculture',
  },
  warehouseManager: {
    boxTypes: [BoxType.In, BoxType.Out],
    visibilityByBoxType: {
      [BoxType.In]: 'destinationWarehouse',
      [BoxType.Out]: 'originWarehouse',
    },
    stateFiltersByBoxType: {
      [BoxType.In]: warehouseManagerInStates,
      [BoxType.Out]: warehouseManagerOutStates,
    },
  },
} as const satisfies Record<string, OrderInboxConfiguration>;

export const ORDER_INBOX_STATE_OPTIONS: Readonly<Record<OrderInboxStateFilter, { labelKey: string; value: OrderState | undefined }>> = {
  [FilterConsts.All]: { labelKey: '::OrderFilterAll', value: undefined },
  [FilterConsts.Pending]: { labelKey: '::OrderFilterPending', value: OrderState.New },
  [FilterConsts.Approved]: { labelKey: '::OrderFilterApproved', value: OrderState.Approved },
  [FilterConsts.Delivered]: { labelKey: '::OrderFilterDelivered', value: OrderState.Delivered },
  [FilterConsts.Received]: { labelKey: '::OrderFilterReceived', value: OrderState.Received },
  [FilterConsts.Rejected]: { labelKey: '::OrderFilterRejected', value: OrderState.Rejected },
};
